import BoardIcon from '@atlaskit/icon/core/board';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import ListChecklistIcon from '@atlaskit/icon/core/list-checklist';

import {
	USER_SEGMENTATION_TEAM_TYPE_MARKETING,
	USER_SEGMENTATION_TEAM_TYPE_SOFTWARE,
	USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
	USER_SEGMENTATION_TEAM_TYPE_DESIGN,
	USER_SEGMENTATION_TEAM_TYPE_SALES,
} from '../../models/user-segmentation';

import { DocSvg } from './assets/doc.tsx';
import { ProjectTrackerSvg } from './assets/projectTracker.tsx';
import { WhiteboardSvg } from './assets/whiteboard.tsx';
import { messages } from './messages';
import { TeamType, WorkOption } from './types';

const TeamTypesWithFlow = new Set([
	USER_SEGMENTATION_TEAM_TYPE_MARKETING,
	USER_SEGMENTATION_TEAM_TYPE_SOFTWARE,
	USER_SEGMENTATION_TEAM_TYPE_PRODUCT_MANAGEMENT,
	USER_SEGMENTATION_TEAM_TYPE_DESIGN,
	USER_SEGMENTATION_TEAM_TYPE_SALES,
]);

export const getTeamTypeWithFlow = (teamType: string | undefined): TeamType => {
	if (teamType && TeamTypesWithFlow.has(teamType as TeamType)) {
		return teamType as TeamType;
	}
	return 'default';
};

export const aiLedOnboardingWorkOptions: WorkOption[] = [
	{
		id: 'project-tracker',
		name: messages.projectTracker,
		icon: CalendarIcon,
		redirect: 'jira',
	},
	{
		id: 'doc',
		name: messages.doc,
		icon: BoardIcon,
		redirect: 'live-doc',
	},
	{
		id: 'whiteboard',
		name: messages.whiteboard,
		icon: ListChecklistIcon,
		redirect: 'whiteboard',
	},
];

export const getAssetByContentType = (contentType: string | null): (() => JSX.Element) => {
	switch (contentType) {
		case 'doc':
			return DocSvg;
		case 'whiteboard':
			return WhiteboardSvg;
		case 'project-tracker':
		default:
			return ProjectTrackerSvg;
	}
};
